/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const AssetTypeJsonApiModel = {
  id: "",
  name: "",
  description: "",
  tags: "",
  "created-at": "",
  "updated-at": "",
};
